<template>
  <div style="height: 500px">
    <img src="./Usr-iot.jpg" height="45" />
    <h5 v-if="info.subtype === 'RS-485'">USR-DR302</h5>
    <h5 v-if="info.subtype === 'RS-232'">USR-DR301</h5>
    <small>Ethernet - {{ info.subtype }}</small>
    <div class="m-1" v-if="shares">
      <span v-if="shares.connected" class="badge bg-success">ONLINE</span>
      <span v-if="!shares.connected" class="badge bg-danger">OFFLINE</span>
    </div>
    <table v-if="shares" class="table table-sm table-striped align-middle text-center mt-3">
      <thead>
        <th>Запросы</th>
      </thead>
      <tbody>
        <tr>
          <td>Всего</td>
        </tr>
        <tr>
          <td>{{ shares.counter }}</td>
        </tr>
        <tr>
          <td>Ошибок</td>
        </tr>
        <tr>
          <td>{{ shares.errors }}</td>
        </tr>
      </tbody>
    </table>
    <table v-if="shares" class="table table-sm table-striped align-middle text-center">
      <thead>
        <th>Сеть</th>
      </thead>
      <tbody>
        <tr>
          <td>Отпр. байт</td>
        </tr>
        <tr>
          <td>{{ hS(shares.byteSend) }}</td>
        </tr>
        <tr>
          <td>Получ. байт</td>
        </tr>
        <tr>
          <td>{{ hS(shares.byteReceive) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "MU210-401",
  props: ["info", "shares", "id"],
  methods: {
    hS: function (bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;
      if (Math.abs(bytes) < thresh) return bytes.toFixed(dp) + " B";
      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u = -1;
      const r = 10 ** dp;
      do {
        bytes /= thresh;
        ++u;
      } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
      );
      return bytes.toFixed(dp) + " " + units[u];
    },
  },
};
</script>
<style scoped>
</style>
